export default {"src":"/_next/static/media/SOFI.23f3c77c.svg","height":18,"width":18};